import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import SessionsTag from 'core/modules/compositions/SessionsTag/SessionsTag';
import PropTypes from 'prop-types';
import React from 'react';
import { IconBubble } from 'ui';

function LessonItemCardSession({ sessions, isTeacherOnly, t, canEditSessions, lessonItemGuid, courseGuid, onSaveSessions, lessonGuid }) {
  return (
    <div className="lesson-item-card-session">
      <SessionsTag
        sessions={sessions}
        canEditSessions={canEditSessions}
        lessonItemGuid={lessonItemGuid}
        courseGuid={courseGuid}
        onSaveSessions={onSaveSessions}
        lessonGuid={lessonGuid}
      />

      {isTeacherOnly && (
        <TooltipCustom title={t('lesson:Teacher only')} placement="top" hasArrow={true}>
          <div className="lesson-item-card__teacher-only">
            <IconBubble name="teacher" size="sm" background="alpha" color="primary" />
          </div>
        </TooltipCustom>
      )}
    </div>
  );
}

LessonItemCardSession.propTypes = {
  canEditSessions: PropTypes.bool,
  lessonItemGuid: PropTypes.string,
  courseGuid: PropTypes.string,
  onSaveSessions: PropTypes.func,
  isTeacherOnly: PropTypes.bool,
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
    })
  ),
  t: PropTypes.func,
  lessonGuid: PropTypes.string,
};

LessonItemCardSession.defaultProps = {
  sessions: [],
};

export default LessonItemCardSession;
